<template>
  <div>
    <s
      class="text-gray-300"
      v-if="data.cancelado === '1' || data.baixa === '1'"
    >
      <div class="text-gray-300">
        <slot></slot>
      </div>
    </s>
    <span v-else>
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>
